<template>
  <div id="resume-experience-description" class="col-12 bg-white-primary mx-auto">
    <div
      class="d-flex flex-column flex-md-row justify-content-md-start align-items-center border-bottom mb-1 mx-0 ps-0 ps-md-3 pe-0"
    >
      <div class="size-16 fw-bold text-center pt-4 pb-2 pb-md-4 ps-0 ps-md-2">職務経歴</div>
      <span class="tag-thirdly size-10 ms-2">必須</span>
    </div>
    <div class="row mx-3 py-4">
      <div class="input-group row">
        <div class="col-12 pe-0">
          <label class="form-label size-12" for="work_experience_description">職務経歴</label>
          <Field
            v-slot="{ field, errors }"
            v-model="jobHistoryStore.work_experience_description"
            name="candidate_resume.work_experience_description"
          >
            <textarea
              id="work_experience_description"
              class="form-control bg-silver-primary input-primary size-14 border-0 lh-20"
              rows="5"
              placeholder="例）webクリエイターとして、さらにレベルアップを図るべく、昨年「カラーコーディネーター」の資格を取得しました。終業時間が不規則なこともあり、限られた時間の活用法を追求するうち、業務を効率よく進める姿勢にもつながりました。"
              v-bind="field"
              :class="{ 'is-invalid': !!errors.length }"
            ></textarea>
            <div
              class="d-flex justify-content-end mt-2 size-10"
              :class="
                jobHistoryStore.work_experience_description?.length > 5000
                  ? 'text-danger'
                  : 'text-black-50'
              "
            >
              {{ jobHistoryStore.work_experience_description?.length || 0 }}
              /5000（最大文字数5000文字）
            </div>
            <ErrorMessage
              name="candidate_resume.work_experience_description"
              class="invalid-feedback"
            />
            <label class="form-label size-12 col-md-12 mt-2 mb-0">
              <span class="me-2">&#8226;</span>
              登録情報をもとに自動で職務経歴書を作成しました。編集して更に履歴書情報を充実させましょう。
            </label>
          </Field>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Field, ErrorMessage } from 'vee-validate';
import { useJobHistoryStore } from '@/stores/resume-candidate/JobHistory.store';

const jobHistoryStore = useJobHistoryStore();
</script>
